import script from "./dashboard-chart.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboard-chart.vue?vue&type=script&setup=true&lang=js"

import "./dashboard-chart.vue?vue&type=style&index=0&id=3364eaba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3364eaba"]])

export default __exports__